import * as React from 'react';

import { useGetReferralLink } from './hooks/useGetReferralLink';

import { StickyFooter } from '../../../components/StickyFooter';
import { Button, useDeviceType } from '@cian/ui-kit';
import { selectIsStickyScrollBtnVisible } from '../../../selectors';
import { useSelector } from 'react-redux';
import { IconActionCopy16, IconActionShareIOS16 } from '@cian/ui-kit-design-tokens/icons';

export const StickyFooterContainer: React.FC = () => {
  const shareBtnRef = React.useRef<HTMLButtonElement>(null);

  const { handleCopyLinkClick, handleShareLinkClick } = useGetReferralLink();

  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const isStickyBtnVisible = useSelector(selectIsStickyScrollBtnVisible);

  if (!isStickyBtnVisible) {
    return null;
  }

  return (
    <StickyFooter
      title="Пригласите друга в Сделку и получите 10 000 ₽"
      isDesktop={isDesktop}
      primaryButton={
        <Button
          beforeIcon={<IconActionCopy16 color={isDesktop ? 'icon-on-bright-default' : 'icon-main-default'} />}
          theme={isDesktop ? 'fill_primary' : 'fill_white_primary'}
          size={isDesktop ? 'L' : 'M'}
          onClick={handleCopyLinkClick}
          fullWidth={!isDesktop}
        >
          {isDesktop ? 'Пригласить по ссылке' : 'Скопировать приглашение'}
        </Button>
      }
      secondaryButton={
        !isDesktop && (
          <Button
            ref={shareBtnRef}
            beforeIcon={<IconActionShareIOS16 color="icon-on-bright-default" />}
            theme="fill_primary"
            size="M"
            onClick={handleShareLinkClick}
            fullWidth
          >
            Поделиться ссылкой
          </Button>
        )
      }
    />
  );
};
